export const NEW = 'new'
export const AT_SIGNING = 'at_signing'
export const SIGNED_ASTER = 'signed_aster'
export const SIGNED_CLIENT = 'signed_client'
export const SIGNED_ALL = 'signed_all'
export const SIGNED = 'signed'
export const SIGNED_LE = 'signed_le'
export const SMS_SENT = 'sms_sent'
export const ACCESSED_LE = 'accessed_le'
export const SENT_DEALER = 'sent_dealer'
export const REFUSED = 'refused'
export const ACCESSED = 'accessed'
export const EXPORTED = 'exported'
